//服务区域,服务城市列表:即当前分院城市列表
export const SERVICE_AREA = [
  {ID: '20200', name: '广州', city: '广州市', province: '广东省', code: '020', hospital: [{name: '广州骏园'}]},
  {
    ID: '20755',
    name: '深圳',
    city: '深圳市',
    province: '广东省',
    code: '0755',
    hospital: [{name: '深圳竹子林'}, {name: '深圳南山分院'}, {name: '深圳罗湖分院'}],
  },
  {ID: '10100', name: '北京', city: '北京市', province: '北京市', code: '010', hospital: [{name: '北京雍贵中心'}]},
  {ID: '20757', name: '佛山', city: '佛山市', province: '广东省', code: '0757', hospital: [{name: '佛山南海'}]},
  {
    ID: '30510',
    name: '无锡',
    city: '无锡市',
    province: '江苏省',
    code: '0510',
    hospital: [{name: '无锡崇安寺馆'}, {name: '无锡南禅寺馆'}],
  },
  {ID: '20760', name: '中山', city: '中山市', province: '广东省', code: '0760', hospital: [{name: '中山西区分院'}]},
  {
    ID: '40591',
    name: '福州',
    city: '福州市',
    province: '福建省',
    code: '0591',
    hospital: [{name: '铭医堂综合门诊部', code: '407'}],
  },
  {
    ID: '30512',
    name: '苏州',
    city: '苏州市',
    province: '江苏省',
    code: '0512',
    hospital: [{name: '桃花坞分院', code: '405'}],
  },
  {
    ID: '30250',
    name: '南京',
    city: '南京市',
    province: '江苏省',
    code: '025',
    hospital: [{name: '南京宁西门诊部', code: '409'}],
  },
  {
    ID: '02100',
    name: '上海',
    city: '上海市',
    province: '上海市',
    code: '021',
    hospital: [{name: '南京宁西门诊部', code: '409'}],
  },
  {
    ID: '76200',
    name: '天津',
    city: '天津市',
    province: '江苏省',
    code: '762',
    hospital: [{name: '南京宁西门诊部', code: '409'}],
  },
  {
    ID: '02800',
    name: '成都',
    city: '成都市',
    province: '江苏省',
    code: '028',
    hospital: [{name: '南京宁西门诊部', code: '409'}],
  },
  {ID: '37610', name: '昆山', city: '昆山市', province: '江苏省', code: '761', hospital: [{name: '昆山朝阳门诊部'}]},
];
//全局定位默认城市
export const DEFAULT_CITY = {code: '020', name: '广州市', data: new Date()};

export const RecipeMap = {
  1: '中草药',
  2: '颗粒剂',
  3: '经验方',
  4: '中成药',
  5: '西药',
  6: '检查',
  7: '检验',
  8: '治疗',
  9: '材料',
  10: '其他',
  11: '经验方制作',
  12: '非医用耗材类',
  13: '食品',
  14: '保健品',
};

export const RecipeProgressMap = {
  0: '配药中',
  1: '待取药',
  2: '排队中',
  3: '已取药',
  4: '已寄药',
};

//性别
export function convertGender(code) {
  const map = {
    1: '男',
    2: '女',
  };
  return map[code] ? map[code] : '未知';
}

//判断是否为视频号
export function isVideoDeal(video) {
  return video && (video.toString() === '1' || video.toString() === '4');
}

//遍历订单状态文字
export function mapDealStateText(stateCode, video) {
  let map = {
    1: '待录入',
    2: '已录入',
    3: '医生已确认',
    4: '患者已确认',
    5: '已支付',
    6: '配药完成',
    7: '打包完成',
    8: '已发货',
    9: '已签收',
    10: '已自提',
    11: '交易结束',
    12: '退款中',
    13: '交易取消',
    14: isVideoDeal(video) ? '已取号' : '已到店',
    15: '已爽约',
    16: '待支付',
    17: '预约成功',
    18: '已取消',
    19: '已退款',
    20: '已退号',
    21: '已生成', //挂号单已生成
    22: '已支付', //挂号单已支付
    23: '已取号', //挂号单已取号
    24: '应诊',
    25: '已就诊',
    26: '已取消',
    27: '已退号',
    28: '退号中',
    29: '已爽约',
    30: '待支付',
    31: '待发货',
    32: '已发货',
    33: '已签收',
    34: '已取消',
    35: '已失效',
  };
  if (map[stateCode]) {
    return map[stateCode];
  } else {
    return '';
  }
}

//遍历订单类型文字
export function mapDealTypeText(typeCode) {
  let map = {
    1: '正常处方单',
    2: '拍照处方单',
    3: '挂号单',
    4: '预约单',
  };
  if (map[typeCode]) {
    return map[typeCode];
  } else {
    return '';
  }
}

export const VIDEO_SUPPORT_MAP = {
  1: '视频看诊',
  2: '均可',
  3: '分院看诊',
  4: '即刻视频看诊',
  5: '图文看诊',
  6: '语音看诊',
};

//隐私条款/服务条款外链
export const SERVER_FILE_LINK = {
  privacy: `https://mobile.patient.bailuzy.com/mobile/user/privacyAgreement`,
  service: `https://static.gstyun.cn/static/agreement.html`,
};

//订单来源的session存储字段
export const SOURCE_KEY = 'SESSION_SOURCE';

//获取地理定位错误码(原生)
export const POSITION_ERROR = {
  1: '用户禁止了地理位置获取',
  2: '位置信息不可用',
  3: '获取位置信息超时',
  4: '获取位置超时',
  5: '当前设备不支持定位',
  6: '微信定位获取失败',
};

//优惠券使用渠道（选填）	number	1<<3：微信 1<<5：PC 1<<18：H5  1<<28 平安金管家
export const CHANNEL_MAP = {
  3: '微信',
  5: 'PC官网',
  18: '移动官网',
  28: '平安',
};
//优惠券类型
export const COUPON_TYPE = {
  1: '挂号券',
  2: '代煎券',
  3: '快递券',
  4: '缴费券',
  5: '零售券',
  6: '红包',
};
